import { render, staticRenderFns } from "./QuickVesselSetup.vue?vue&type=template&id=e60ea358&scoped=true"
import script from "./QuickVesselSetup.vue?vue&type=script&lang=js"
export * from "./QuickVesselSetup.vue?vue&type=script&lang=js"
import style0 from "./QuickVesselSetup.vue?vue&type=style&index=0&id=e60ea358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60ea358",
  null
  
)

export default component.exports